import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a263d6f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ribbon"
}
const _hoisted_2 = { href: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.ribbonEnabled)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.ribbonEnv), 1 /* TEXT */)
      ]))
    : _createCommentVNode("v-if", true)
}